import MetaPixel from "../Components/Pixel/MetaPixel";
import Home from "../pages/Home";
import { Container } from "./App.styled";

function App() {
  return (
    <Container>
      <MetaPixel />
      <Home />
    </Container>
  );
}

export default App;